/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const EnglishFlag = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_6155_32397)">
          <path
            d="M23.3639 6.00098H0.626953V17.9804H23.3639V6.00098Z"
            fill="white"
          />
          <path
            d="M23.3658 10.7946H13.3544V6.00183H10.6216V10.7946H0.636719V13.1896H10.6216V17.9804H13.3544V13.1896H23.3658V10.7946Z"
            fill="#CE1124"
          />
          <path
            d="M0.626953 7.39612V10.0044H5.5862L0.626953 7.39612Z"
            fill="#00247D"
          />
          <path
            d="M3.36173 6.00061L3.28906 6.00391L9.71945 9.40381V6.00061H3.36173Z"
            fill="#00247D"
          />
          <path
            d="M8.25866 9.98769L0.626953 6.0011V6.94073L6.4401 9.98769H8.25866Z"
            fill="#CE1124"
          />
          <path
            d="M15.7383 13.9927L23.37 17.9793V17.0396L17.5568 13.9927H15.7383Z"
            fill="#CE1124"
          />
          <path
            d="M0.626953 16.6045V13.9962H5.5862L0.626953 16.6045Z"
            fill="#00247D"
          />
          <path
            d="M3.36173 18L3.28906 17.9967L9.71945 14.5968V18H3.36173Z"
            fill="#00247D"
          />
          <path
            d="M8.22049 13.9924L0.632812 17.9773L2.40736 17.979L9.7288 14.1545V13.9924H8.22049Z"
            fill="#CE1124"
          />
          <path
            d="M23.3713 7.39551V10.0037H18.4121L23.3713 7.39551Z"
            fill="#00247D"
          />
          <path
            d="M20.635 6L20.7077 6.00329L14.2773 9.40318V6H20.635Z"
            fill="#00247D"
          />
          <path
            d="M23.3611 6.00551L21.6543 6.00537L14.2812 9.85685V9.99197H15.8411L23.3611 6.00551Z"
            fill="#CE1124"
          />
          <path
            d="M23.3713 16.6035V13.9952H18.4121L23.3713 16.6035Z"
            fill="#00247D"
          />
          <path
            d="M20.635 17.999L20.7077 17.9957L14.2773 14.5958V17.999H20.635Z"
            fill="#00247D"
          />
        </g>
        <defs>
          <clipPath id="clip0_6155_32397">
            <rect
              width="16"
              height="12"
              fill="white"
              transform="translate(4 6)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6155_32402)">
        <path
          d="M19.3639 2.00098H-3.37305V13.9804H19.3639V2.00098Z"
          fill="white"
        />
        <path
          d="M19.3658 6.79457H9.35442V2.00183H6.62165V6.79457H-3.36328V9.18963H6.62165V13.9804H9.35442V9.18963H19.3658V6.79457Z"
          fill="#CE1124"
        />
        <path
          d="M-3.37305 3.39612V6.00437H1.5862L-3.37305 3.39612Z"
          fill="#00247D"
        />
        <path
          d="M-0.638275 2.00061L-0.710938 2.00391L5.71945 5.40381V2.00061H-0.638275Z"
          fill="#00247D"
        />
        <path
          d="M4.25866 5.98769L-3.37305 2.0011V2.94073L2.4401 5.98769H4.25866Z"
          fill="#CE1124"
        />
        <path
          d="M11.7383 9.99268L19.37 13.9793V13.0396L13.5568 9.99268H11.7383Z"
          fill="#CE1124"
        />
        <path
          d="M-3.37305 12.6045V9.99622H1.5862L-3.37305 12.6045Z"
          fill="#00247D"
        />
        <path
          d="M-0.638275 14L-0.710938 13.9967L5.71945 10.5968V14H-0.638275Z"
          fill="#00247D"
        />
        <path
          d="M4.22049 9.99243L-3.36719 13.9773L-1.59264 13.979L5.7288 10.1545V9.99243H4.22049Z"
          fill="#CE1124"
        />
        <path
          d="M19.3713 3.39551V6.00375H14.4121L19.3713 3.39551Z"
          fill="#00247D"
        />
        <path
          d="M16.635 2L16.7077 2.00329L10.2773 5.40318V2H16.635Z"
          fill="#00247D"
        />
        <path
          d="M19.3611 2.00551L17.6543 2.00537L10.2812 5.85685V5.99197H11.8411L19.3611 2.00551Z"
          fill="#CE1124"
        />
        <path
          d="M19.3713 12.6035V9.99524H14.4121L19.3713 12.6035Z"
          fill="#00247D"
        />
        <path
          d="M16.635 13.999L16.7077 13.9957L10.2773 10.5958V13.999H16.635Z"
          fill="#00247D"
        />
      </g>
      <defs>
        <clipPath id="clip0_6155_32402">
          <rect
            width="16"
            height="12"
            fill="white"
            transform="translate(0 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EnglishFlag;
